export const JWT_TOKEN_COOKIE_NAME = '_q20_os_jwt'
